import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Feature from "ol/Feature.js";
import {
  addLayer,
  formatGEOJSONLayer,
  getLayerIdByName,
  key,
  trans,
} from "../../lib/utils";
import { useSelector } from "react-redux";
import store from "../../stores/store";
import { useEffect, useState } from "react";
import Draw from "ol/interaction/Draw";
import { getLayerById, getMapProjection } from "../map/mapUtils";
import { Modify, defaults as defaultInteractions } from "ol/interaction.js";
import md5 from "md5";
import Form1 from "./form1";
import {
  FeatureToGeoJSON,
  getAttributesFromGeoJSON,
  showFeature,
} from "../../lib/featureUtils";
import Formio from "./formio/formio";
import FormioSubmissions from "./formio/formioSubmissions";
import { functions } from "lodash";
import {
  LineString,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Point,
  Polygon,
} from "ol/geom";
import { cloneDeep } from "lodash";

function Forms() {
  const selectedForm = useSelector(
    (state) => store.getState().forms.selectedForm
  );

  const selectedFormObject = useSelector(
    (state) => store.getState().forms.selectedFormObject
  );

  const selectedLayer = useSelector(
    (state) => store.getState().forms.selectedLayer
  );

  const selectedSubmission = useSelector(
    (state) => store.getState().forms.selectedSubmission
  );

  let selectedFeature = useSelector(
    (state) => store.getState().forms.selectedFeature
  );

  let showNewButtons = useSelector(
    (state) => store.getState().forms.showNewButtons
  );

  let maximumFeaturesPerForm = useSelector(
    (state) => store.getState().forms.maximumFeaturesPerForm
  );

  let selectedTab = useSelector((state) => store.getState().forms.selectedTab);

  const forms = useSelector((state) => store.getState().forms.forms);

  const layers = useSelector((state) => store.getState().layers);

  const [currentFormFeatureGroupId, setCurrentFormFeatureGroupId] = useState(
    key()
  );

  useEffect(() => {
    if (selectedFeature) {
      window["map"].removeInteraction(window["formFeatureModify"]);
      window["formFeatureModify"] = new Modify({
        source: getLayerById(selectedLayer).getSource(),
      });

      window["formFeatureModify"].on("modifyend", (e) => {
        store.dispatch({
          type: "forms/feature/select",
          payload: e.features.getArray()[0],
        });
      });
      window["map"].addInteraction(window["formFeatureModify"]);
    }
  }, [selectedLayer, selectedFeature]);

  function formsDrawFeature(type, drawend) {
    onLayerFeature(selectedLayer);
    window["formsPointDraw"] = new Draw({
      source: getLayerById(selectedLayer).getSource(),
      type: type,
    });
    window["formsPointDraw"].on("drawend", function (e) {
      if (drawend) {
        drawend(e);
      }
      window["map"].removeInteraction(window["formsPointDraw"]);
      window["formsPointDraw"] = null;
    });
    window["map"].addInteraction(window["formsPointDraw"]);
  }

  function onAddFeature(e) {
    window["map"].removeInteraction(window["formsPointDraw"]);

    let _featureId = "";

    switch (e.feature.getId()) {
      case "north":
        _featureId = "north";
        break;

      case "south":
        _featureId = "south";
        break;

      case "west":
        _featureId = "west";
        break;

      case "east":
        _featureId = "east";
        break;

      default:
        _featureId = key();
        break;
    }
    //e.feature.getId();

    // if (!_featureId) {
    //   _featureId = key();
    // }

    let _groupFeatureId =
      "group_" + currentFormFeatureGroupId + "_" + _featureId;
    console.log(_groupFeatureId);
    e.feature.setId(_groupFeatureId);

    store.dispatch({ type: "forms/feature/select", payload: e.feature });
  }

  function onLayerFeature(layer) {
    getLayerById(layer).getSource().once("addfeature", onAddFeature);

    getLayerById(layer)
      .getSource()
      .on("removefeature", (e) => {
        window["map"].removeInteraction(window["formsPointDraw"]);
      });
  }

  function updateFeature(properties) {
    if (selectedLayer) {
      let currentFeatureGeometryTypes = {
        point: [],
        polygon: [],
        line: [],
      };

      let isCollection = false;
      let mergedFeature = new Feature();

      getLayerById(selectedLayer)
        .getSource()
        .getFeatures()
        .forEach((feature) => {
          switch (feature.getGeometry().getType()) {
            case "Polygon":
              currentFeatureGeometryTypes.polygon.push(feature);
              break;

            case "LineString":
              currentFeatureGeometryTypes.line.push(feature);
              break;

            case "Point":
              currentFeatureGeometryTypes.point.push(feature);
              break;
          }
        });

      let countMulti = 0;
      Object.keys(currentFeatureGeometryTypes).forEach((el) => {
        if (currentFeatureGeometryTypes[el].length > 0) {
          countMulti++;
        }
      });

      if (countMulti > 1) {
        isCollection = true;
      }

      Object.keys(currentFeatureGeometryTypes).forEach((el) => {
        try {
          let newComponents = [];
          if (currentFeatureGeometryTypes[el].length > 1) {
            switch (el) {
              case "point":
                currentFeatureGeometryTypes[el].forEach((feature) => {
                  newComponents.push(feature.getGeometry().getCoordinates());
                  getLayerById(selectedLayer)
                    .getSource()
                    .removeFeature(feature);
                });

                mergedFeature.setGeometry(new MultiPoint(newComponents));

                break;

              case "polygon":
                currentFeatureGeometryTypes[el].forEach((feature) => {
                  newComponents.push(feature.getGeometry().getCoordinates());
                  getLayerById(selectedLayer)
                    .getSource()
                    .removeFeature(feature);
                });

                mergedFeature.setGeometry(new MultiPolygon(newComponents));

                break;

              case "line":
                currentFeatureGeometryTypes[el].forEach((feature) => {
                  newComponents.push(feature.getGeometry().getCoordinates());
                  getLayerById(selectedLayer)
                    .getSource()
                    .removeFeature(feature);
                });

                mergedFeature.setGeometry(new MultiLineString(newComponents));
                break;
            }
          } else {
            switch (el) {
              case "point":
                currentFeatureGeometryTypes[el].forEach((feature) => {
                  newComponents.push(feature.getGeometry().getCoordinates());
                  getLayerById(selectedLayer)
                    .getSource()
                    .removeFeature(feature);
                });

                mergedFeature.setGeometry(new Point(newComponents));

                break;

              case "polygon":
                currentFeatureGeometryTypes[el].forEach((feature) => {
                  newComponents.push(feature.getGeometry().getCoordinates());
                  getLayerById(selectedLayer)
                    .getSource()
                    .removeFeature(feature);
                });

                mergedFeature.setGeometry(new Polygon(newComponents));

                break;

              case "line":
                currentFeatureGeometryTypes[el].forEach((feature) => {
                  newComponents.push(feature.getGeometry().getCoordinates());
                  getLayerById(selectedLayer)
                    .getSource()
                    .removeFeature(feature);
                });

                mergedFeature.setGeometry(new LineString(newComponents));
                break;
            }
          }
        } catch (e) {
          console.log(e);
        }
      });

      try {
        mergedFeature.setId(currentFormFeatureGroupId);

        getLayerById(selectedLayer).getSource().addFeatures([mergedFeature]);

        Object.keys(properties).forEach((el) => {
          if (Array.isArray(properties[el])) {
            properties[el] = properties[el].join(",");
          }
        });
      } catch (e) {
        console.log(e);
      }

      mergedFeature?.setProperties({ ...properties });

      store.dispatch({
        type: "source/update",
        payload: {
          id: layers[selectedLayer].source.id,
          property: "url",
          value: JSON.stringify(
            FeatureToGeoJSON(
              getLayerById(selectedLayer).getSource().getFeatures()
            )
          ),
        },
      });

      let attributes = getAttributesFromGeoJSON(
        FeatureToGeoJSON(getLayerById(selectedLayer).getSource().getFeatures())
      );

      store.dispatch({
        type: "layer/update",
        payload: {
          id: selectedLayer,
          property: "attributes",
          value: attributes,
        },
      });

      store.dispatch({
        type: "forms/feature/select",
        payload: null,
      });

      setCurrentFormFeatureGroupId(key());
    }
  }

  function setForm() {
    switch (selectedForm) {
      case "Form2":
        return (
          <Form1
            selectedFeature={selectedFeature}
            saveAction={updateFeature}
            form={selectedForm}
            selectedFormObject={selectedFormObject}
          ></Form1>
        );

        break;

      default:
        if (selectedFormObject?.configuration) {
          if (selectedFormObject?.configuration?.type === "formio") {
            return (
              <Formio
                key={currentFormFeatureGroupId}
                //selectedFeature={selectedFeature}
                formsDrawFeature={formsDrawFeature}
                selectedLayer={selectedLayer}
                saveAction={updateFeature}
                currentFormFeatureGroupId={currentFormFeatureGroupId}
                // form={selectedForm}
                // selectedFormObject={selectedFormObject}
                // selectedSubmission={selectedSubmission}
              ></Formio>
            );
          }
        }

        return null;
        break;
    }
  }

  function createSubmissionList() {
    if (selectedFormObject?.configuration) {
      if (selectedFormObject?.configuration?.type === "formio") {
        return (
          <PerfectScrollbar style={{ height: "calc(100vh - 15rem)" }}>
            <FormioSubmissions
              key={key()}
              selectedFeature={selectedFeature}
              selectedLayer={selectedLayer}
              saveAction={updateFeature}
              form={selectedForm}
              selectedFormObject={selectedFormObject}
            ></FormioSubmissions>
          </PerfectScrollbar>
        );
      }
    }
    return (
      <PerfectScrollbar style={{ height: "calc(100vh - 15rem)" }}>
        {selectedLayer
          ? getLayerById(selectedLayer)
              .getSource()
              .getFeatures()
              .map((el, idx) => {
                return (
                  <div className="card mt-3 ">
                    <div className="  me-2 mt-1 d-flex ps-3 pt-2" role="button">
                      <span className="color-get-blue w-100">
                        {trans("Feature").concat(" ", idx + 1)}
                      </span>
                      <i
                        className="fas fa-pencil-alt color-black fa-sm me-2"
                        onClick={() => {}}
                      ></i>
                      <i
                        className="fas fa-trash-alt color-black fa-sm"
                        onClick={() => {}}
                      ></i>
                    </div>
                    <div className="card-body">
                      <div className=" text-end">
                        <button
                          className="btn btn-white btn-sm border me-2"
                          onClick={() => {
                            // getFeatureInfo(
                            //   el.event,
                            //   layers,
                            //   sources,
                            //   store
                            // );
                          }}
                        >
                          <span className="small">
                            {trans("Get feature info")}
                          </span>
                        </button>
                        <button className="btn btn-success btn-sm">
                          <span
                            className="text-white small"
                            onClick={() => {
                              let feature = FeatureToGeoJSON(el);

                              feature.projection = getMapProjection();

                              showFeature(feature);
                            }}
                          >
                            {trans("Show point")}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
          : null}
      </PerfectScrollbar>
    );
  }

  function countSameGroupFeatures() {
    let groupCount = 0;

    if (selectedLayer) {
      getLayerById(selectedLayer)
        .getSource()
        .getFeatures()
        .forEach((feature) => {
          try {
            let fid = feature.getId();
            console.log(fid);
            if (fid.startsWith("group_" + currentFormFeatureGroupId)) {
              groupCount++;
            }
          } catch (e) {}
        });
    }
    return groupCount;
  }

  function topMenu() {
    let _topmenu = [];

    switch (true) {
      case showNewButtons !== null &&
        showNewButtons !== false &&
        selectedLayer !== null &&
        //selectedFeature === null &&
        countSameGroupFeatures() < maximumFeaturesPerForm &&
        selectedForm !== null:
        if (selectedFormObject?.geometryTypes.indexOf("point") >= 0) {
          _topmenu.push(
            <button
              type="button"
              className="btn btn-link border rounded btn-sm"
              onClick={() => {
                formsDrawFeature("Point");
              }}
            >
              {trans("Draw Point")}
            </button>
          );
        }

        if (selectedFormObject?.geometryTypes.indexOf("polygon") >= 0) {
          _topmenu.push(
            <button
              type="button"
              className="btn btn-link border rounded btn-sm ms-2"
              onClick={() => {
                formsDrawFeature("Polygon");
              }}
            >
              {trans("Draw Polygon")}
            </button>
          );
        }

        if (selectedFormObject?.geometryTypes.indexOf("line") >= 0) {
          _topmenu.push(
            <button
              type="button"
              className="btn btn-link border rounded btn-sm ms-2"
              onClick={() => {
                formsDrawFeature("LineString");
              }}
            >
              {trans("Draw Line")}
            </button>
          );
        }

        if (selectedFormObject?.geometryTypes.indexOf("nswe") >= 0) {
          _topmenu.push(
            <button
              type="button"
              className="btn btn-link border rounded btn-sm ms-2 mb-2"
              onClick={() => {
                formsDrawFeature("Point", (e) => {
                  e.feature.setId("north");
                });
              }}
            >
              {trans("Set North point")}
            </button>
          );
          _topmenu.push(
            <button
              type="button"
              className="btn btn-link border rounded btn-sm ms-2 mb-2"
              onClick={() => {
                formsDrawFeature("Point", (e) => {
                  e.feature.setId("east");
                });
              }}
            >
              {trans("Set East point", { _key: "east" })}
            </button>
          );
          _topmenu.push(
            <button
              type="button"
              className="btn btn-link border rounded btn-sm ms-2 mb-2"
              onClick={() => {
                formsDrawFeature("Point", (e) => {
                  e.feature.setId("south");
                });
              }}
            >
              {trans("Set South point")}
            </button>
          );
          _topmenu.push(
            <button
              type="button"
              className="btn btn-link border rounded btn-sm ms-2 mb-2"
              onClick={() => {
                formsDrawFeature("Point", (e) => {
                  e.feature.setId("west");
                });
              }}
            >
              {trans("Set West point")}
            </button>
          );
        }

        // if (selectedFormObject?.geometryTypes.indexOf("custom") >= 0) {
        //   if (
        //     typeof selectedFormObject?.customGeometryTypeFunction === "function"
        //   ) {
        //     _topmenu.push(
        //       selectedFormObject?.customGeometryTypeFunction(
        //         formsDrawFeature,
        //         trans
        //       )
        //     );
        //   }
        // }
        // _topmenu.push(
        //   <button
        //     type="button"
        //     className="btn btn-link border rounded btn-sm"
        //     onClick={() => {
        //       formsDrawFeature("Point");
        //     }}
        //   >
        //     {trans("Draw Point")}
        //   </button>
        // );

        break;

      case selectedForm === null:
        _topmenu = [<p>{trans("Select a form first from the dropdown")}</p>];
        break;

      case selectedFeature !== null:
        _topmenu = [
          <button
            type="button"
            className="btn btn-danger border rounded btn-sm text-white"
            onClick={() => {
              getLayerById(selectedLayer)
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                  if (
                    feature
                      .getId()
                      .startsWith("group_".concat(currentFormFeatureGroupId))
                  ) {
                    getLayerById(selectedLayer)
                      .getSource()
                      .removeFeature(feature);
                  }
                });

              store.dispatch({
                type: "forms/feature/select",
                payload: null,
              });
            }}
          >
            {trans("Delete feature")}
          </button>,
          <div className="mt-2 small">
            {trans(
              "You can also change feature position and shape by modifying it on the map"
            )}
          </div>,
        ];
        break;
    }

    return _topmenu;
  }

  return (
    <div className="me-3">
      <div className="mt-2">
        <select
          className="form-select form-select-sm "
          value={selectedForm}
          onChange={(e) => {
            let selected = { form: e.target.value };

            {
              Object.keys(layers).map((el) => {
                forms.map((f) => {
                  if (
                    f.layerName === layers[el].name &&
                    selected.form === f.form
                  ) {
                    selected.layer = layers[el].id;
                    selected.formObject = f;
                  }
                });
              });
            }

            store.dispatch({
              type: "forms/select",
              payload: {
                form: selected.form,
                layer: selected.layer,
                selectedFormObject: selected.formObject,
              },
            });
          }}
        >
          <option value="">{trans("Select a form")}</option>
          {Object.keys(layers).map((el) => {
            return forms.map((f) => {
              if (f.layerName === layers[el].name) {
                return <option value={f.form}>{f.title}</option>;
              }
            });
          })}
        </select>
      </div>
      <PerfectScrollbar style={{ height: "45px", overflowY: "none" }}>
        <ul className="nav nav-tabs navbar-expand small">
          <li
            className="nav-item "
            role="button"
            onClick={() => {
              store.dispatch({
                type: "forms/selectedTab",
                payload: "form",
              });
            }}
          >
            <span
              className={
                selectedTab === "form"
                  ? "nav-link color-strong-grey nav-ellipsis  active"
                  : "nav-link color-strong-grey nav-ellipsis"
              }
              // data-bs-toggle="tab"
              // data-bs-target={"#form"}
            >
              <span className="color-black">{trans("Form")}</span>
            </span>
          </li>
          {selectedFormObject?.showHistory === false ? (
            ""
          ) : (
            <li
              className="nav-item "
              role="button"
              onClick={() => {
                store.dispatch({
                  type: "forms/selectedTab",
                  payload: "form-features",
                });
              }}
            >
              <span
                className={
                  selectedTab === "form-features"
                    ? "nav-link color-strong-grey nav-ellipsis  active"
                    : "nav-link color-strong-grey nav-ellipsis"
                }
                // data-bs-toggle="tab"
                // data-bs-target={"#form-features"}
              >
                <span className="color-black">{trans("Features")}</span>
              </span>
            </li>
          )}
        </ul>
      </PerfectScrollbar>
      <div className="tab-content mt-3 ">
        <div
          // className="tab-pane fade active show"
          className={
            selectedTab === "form"
              ? "tab-pane fade active show"
              : "tab-pane fade"
          }
          id="form"
          role="tabpanel"
          aria-labelledby="form"
        >
          <div className="mt-2">{topMenu()}</div>
          <div id="form-alert-id"></div>
          <PerfectScrollbar style={{ height: "calc(100vh - 18rem)" }}>
            {/* <div className="mt-2">{selectedFeature ? setForm() : null}</div> */}
            <div className="mt-2">{setForm()}</div>
          </PerfectScrollbar>
        </div>
        {selectedFormObject?.showHistory === false ? (
          ""
        ) : (
          <div
            // className="tab-pane fade"
            className={
              selectedTab === "form-features"
                ? "tab-pane fade active show"
                : "tab-pane fade"
            }
            id="form-features"
            role="tabpanel"
            aria-labelledby="form-features"
          >
            {createSubmissionList()}
          </div>
        )}
      </div>
    </div>
  );
}

export default Forms;
